var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFnbAddGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C6.26818 0 0 6.26818 0 14C0 21.7318 6.26818 28 14 28C21.7318 28 28 21.7318 28 14C28 6.26818 21.7318 0 14 0ZM15.2727 19.0909C15.2727 19.4285 15.1386 19.7522 14.9 19.9909C14.6613 20.2295 14.3375 20.3636 14 20.3636C13.6625 20.3636 13.3387 20.2295 13.1 19.9909C12.8614 19.7522 12.7273 19.4285 12.7273 19.0909V15.2727H8.90909C8.57154 15.2727 8.24782 15.1386 8.00914 14.9C7.77045 14.6613 7.63636 14.3375 7.63636 14C7.63636 13.6625 7.77045 13.3387 8.00914 13.1C8.24782 12.8614 8.57154 12.7273 8.90909 12.7273H12.7273V8.90909C12.7273 8.57154 12.8614 8.24782 13.1 8.00914C13.3387 7.77045 13.6625 7.63636 14 7.63636C14.3375 7.63636 14.6613 7.77045 14.9 8.00914C15.1386 8.24782 15.2727 8.57154 15.2727 8.90909V12.7273H19.0909C19.4285 12.7273 19.7522 12.8614 19.9909 13.1C20.2295 13.3387 20.3636 13.6625 20.3636 14C20.3636 14.3375 20.2295 14.6613 19.9909 14.9C19.7522 15.1386 19.4285 15.2727 19.0909 15.2727H15.2727V19.0909Z",
    fill: "#C09E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFnbAddGold);
export default __webpack_public_path__ + "static/media/fnb-add-gold.2d936fbb.svg";
export { ForwardRef as ReactComponent };